<template>
  <header class="header">
    <div class="content">
      <div class="header-bar clearfix">
        <router-link class="logo" to="/"></router-link>
        <ul class="nav fr">
          <li>
            <router-link class="nav-item" to="/">首页</router-link>
          </li>
          <li>
            <router-link class="nav-item" to="/product">产品中心</router-link>
          </li>
          <li>
            <router-link class="nav-item" to="/joinus">加入我们</router-link>
          </li>
          <li @mouseenter="handlerMouseenter" @mouseleave="handlerMouseleave">
            <router-link class="nav-item" :to="{path: '/about'}">关于我们</router-link>
            <transition name="slide-fade">
              <div v-if="show" class="menu">
                <span
                  v-for="(item,index) in mainMenu"
                  :key="index"
                  @click.self="handleLink(item.index)"
                >{{item.name}}</span>
              </div>
            </transition>
          </li>
        </ul>
        <div class="header-button hide" @click="handleMenu" :class="{active:isClass}">
          <i></i>
        </div>
      </div>

      <div class="header-menu hide">
        <transition name="slide-fade">
          <div v-if="isShow" class="header-menu-list">
            <span
              v-for="(item,index) in subMenu"
              :key="index"
              @click="jumpPage(item.path)"
            >{{item.name}}</span>
          </div>
        </transition>

        <div class="header-mask" v-if="isShow"></div>
      </div>
    </div>
  </header>
</template>

<script>
import { fail } from "assert";
export default {
  data() {
    return {
      show: false,
      isClass: false,
      isShow: false,
      mainMenu: [
        {
          name: "公司简介",
          index: 0
        },
        {
          name: "发展历程",
          index: 1
        },
        {
          name: "公司荣誉",
          index: 2
        },
        {
          name: "联系我们",
          index: 3
        }
      ],
      subMenu: [
        {
          name: "首页",
          path: "/"
        },
        {
          name: "产品中心",
          path: "/product"
        },
        {
          name: "加入我们",
          path: "/joinus"
        },
        {
          name: "关于我们",
          path: "/about"
        }
      ]
    };
  },
  methods: {
    handlerMouseenter: function() {
      this.show = true;
    },
    handlerMouseleave: function() {
      this.show = false;
    },
    handleMenu: function() {
      this.isClass = !this.isClass;
      this.isShow = !this.isShow;
    },
    jumpPage: function(path) {
      this.isClass = false;
      this.isShow = false;
      this.$router.push({
        path: path
      });
    },
    handleLink: function(index) {
      this.isClass = false;
      this.show = false;
      this.$router.push({
        path: "/about",
        query: {
          index: index
        }
      });
    }
  }
};
</script>

<style scoped>

.header {
  height: 82px;
  box-shadow: 0px 1px 0px 0px rgba(221, 221, 221, 1);
  background-color: #fff;
}

.header .logo {
  background: url(../assets/image/logo.svg) no-repeat center;
  width: 138px;
  height: 59px;
  float: left;
  margin: 7px 0 0 10px;
}

.nav li {
  float: left;
  margin-right: 60px;
  position: relative;
}

.nav-item {
  width: 96px;
  height: 82px;
  line-height: 82px;
  text-align: center;
  font-size: 20px;
  display: block;
  position: relative;
  transition: all 0.2s;
}

.nav-item.router-link-exact-active,
.nav-item:hover {
  color: #e23251;
  font-weight: bold;
}

.nav-item::after {
  content: "";
  width: 0;
  height: 6px;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: 0;
  opacity: 0;
  transition: all 0.3s;
}

.nav-item.router-link-exact-active::after,
.nav-item:hover::after {
  width: 96px;
  background-color: #e23251;
  margin-left: -48px;
  opacity: 1;
}

.nav .menu {
  width: 96px;
  background-color: #f7f7f7;
  position: absolute;
  left: 0;
  bottom: -148px;
  z-index: 5;
  padding: 5px 0;
}

.nav .menu span {
  display: block;
  height: 36px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
}
.nav .menu a:hover,
.nav .menu span:hover{
  color: #e23251;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}

@media (max-width: 1200px) {
  .content {
    width: auto;
  }
  .nav {
    display: none;
  }
  .header {
    height: 60px;
  }
  .header .logo {
    width: 80px;
    height: 40px;
    background-size: 100px 40px;
  }
  .header-bar {
    position: relative;
    z-index: 9;
    height: 60px;
    overflow: hidden;
    background-color: #fff;
  }
  .header-button {
    display: -webkit-box;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    height: 60px;
    position: absolute;
    right: 15px;
    top: 0;
  }
  .header-button i {
    background: url(../assets/image/ic_menu.svg) no-repeat;
    width: 32px;
    height: 26px;
    background-size: 32px 26px;
    display: block;
  }

  .header-button.active i {
    background: url(../assets/image/ic_slose.svg) no-repeat center;
    background-size: 32px 26px;
  }
  .header-menu {
    position: relative;
    z-index: 2;
    display: block;
  }

  .header-menu-list {
    position: absolute;
    background-color: #fff;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 10;
    padding: 5px 0;
    border-top: 3px solid #efefef;
  }

  .header-menu-list span {
    display: block;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  .header-mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 2;
  }
}
</style>s
